import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.CONTRACT_STEPS,
    method: "get",
    params,
  });
}

export default {
  list,
};
